(() => {
  function startSnow(canvas) {
    if (!canvas || canvas.dataset.snowInit) return false;
    canvas.dataset.snowInit = "1";

    const ctx = canvas.getContext("2d");
    if (!ctx) return false;

    const flakes = [];
    const state = { rafId: null };
    const config = {
      maxFlakes: window.innerWidth <= 768 ? 320 : 500,
      gravity: window.innerWidth <= 768 ? 2.6 : 2.1,
      minRadius: 0.8,
      maxRadius: 3.5,
      minSpeed: 0.8,
      maxSpeed: 2.2,
      drift: 0.12,
      spawnPerFrame: window.innerWidth <= 768 ? 6 : 8,
    };

    function setCanvasSize() {
      const dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      const width = window.innerWidth;
      const height = window.innerHeight;

      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const cssColor = getComputedStyle(canvas)
        .getPropertyValue("--lp-snow-color")
        .trim();
      ctx.fillStyle = cssColor || "#ffffff";

      config.maxFlakes = window.innerWidth <= 768 ? 320 : 500;
      config.gravity = window.innerWidth <= 768 ? 2.6 : 2.1;
      config.spawnPerFrame = window.innerWidth <= 768 ? 6 : 8;
    }

    function newFlake({ inView = false } = {}) {
      const width = window.innerWidth;
      const height = window.innerHeight;

      const x = Math.random() * width;
      const y = inView ? Math.random() * height : -10 - Math.random() * height * 1.2;
      const radius =
        config.minRadius + Math.random() * (config.maxRadius - config.minRadius);
      const speed =
        config.minSpeed + Math.random() * (config.maxSpeed - config.minSpeed);
      const vx = (Math.random() - 0.5) * config.drift;

      flakes.push({ x, y, radius, speed, vx });
    }

    function seedInitialFlakes() {
      flakes.length = 0;

      const inViewCount = Math.floor(config.maxFlakes * 0.65);
      for (let i = 0; i < inViewCount; i++) newFlake({ inView: true });

      const staggeredCount = Math.floor(config.maxFlakes * 0.2);
      for (let i = 0; i < staggeredCount; i++) newFlake({ inView: false });
    }

    function draw() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      ctx.clearRect(0, 0, width, height);

      for (const flake of flakes) {
        ctx.beginPath();
        ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function tick() {
      if (flakes.length < config.maxFlakes) {
        const toSpawn = Math.min(
          config.spawnPerFrame,
          config.maxFlakes - flakes.length
        );
        for (let i = 0; i < toSpawn; i++) newFlake();
      }

      const width = window.innerWidth;
      const height = window.innerHeight;

      for (let i = flakes.length - 1; i >= 0; i--) {
        const flake = flakes[i];
        flake.x += flake.vx;
        flake.y += config.gravity + flake.speed;

        if (flake.y > height + 10 || flake.x < -20 || flake.x > width + 20) {
          flakes.splice(i, 1);
        }
      }

      draw();
      state.rafId = requestAnimationFrame(tick);
    }

    setCanvasSize();
    seedInitialFlakes();
    tick();

    window.addEventListener("resize", setCanvasSize, { passive: true });
    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.hidden) {
          if (state.rafId) cancelAnimationFrame(state.rafId);
          state.rafId = null;
          return;
        }
        if (!state.rafId) tick();
      },
      { passive: true }
    );

    return true;
  }

  const canvas = document.getElementById("lp-snow-canvas");
  if (canvas) startSnow(canvas);
})();

